import onetime from "@-/com.npmjs.onetime";
import { onDeadlineExceeded } from "@-/dev.improve.haniverse.lib.deadline";
import { captureSentryException } from "@-/dev.improve.haniverse.lib.sentry";

/**
 * Report every ENFORCED deadline (see `@-/dev.improve.haniverse.lib.deadline`). The learner
 * was handed a retry instead of an endless spinner, but a wait that needed its deadline is a bug
 * somewhere: this is how it gets found. Grouped by operation, like the stuck-step watchdog.
 * Idempotent; the app installs it once alongside its root query client.
 */
export const installDeadlineExceededReporter = onetime((): void => {
  onDeadlineExceeded((error) => {
    captureSentryException(error, {
      contexts: { "han.deadline": { deadlineMs: error.deadlineMs, operation: error.operation } },
      fingerprint: ["deadline-exceeded", error.operation],
      level: "error",
      tags: { "han.deadline.operation": error.operation },
    });
  });
});
